<template>
    <div v-if="isDisplay"
        :class="['preview-text', formText.positionIndex != maxComponent - 1 ? 'm-b-16' : '']">
        <div :class="['swift-text in-app']">
            <div class="loading-text">
                <p class="m-0" v-html="formText.text" :style="'color: ' + formText.color + '; font-family:' + formText.font" :class="['fw-' + formText.fontWeight, 'fz-'+formText.size]"></p>
            </div>
        </div>
    </div>
</template>
<script>
import { listComponentDefault } from './../../constant'
export default {
    name: "PreviewText",
    props: {
        value: {
            type: Object,
            required: true,
        },
        isDisplay: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        formText: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
        maxComponent() {
            return listComponentDefault.length
        }
    },

    data() {
        return {
           
        };
    },

    created() {},
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Alegreya&family=Arvo&family=Cabin&family=Crimson+Text&family=Lora&family=Merriweather&family=Open+Sans&family=Playfair+Display&family=Poppins&family=Roboto&display=swap');

    .preview-text {
        width: 100%;
    }
</style>
